var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTutorialsInitiative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 22.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tutorials-initiative") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.88,7.06H22.06a.88.88,0,0,1,.88.88V21.18a.88.88,0,0,1-.88.88H.88A.88.88,0,0,1,0,21.18V7.94A.88.88,0,0,1,.88,7.06Zm23.82,11V5.29H4a.44.44,0,0,1-.44-.45V4A.44.44,0,0,1,4,3.53H25.59a.88.88,0,0,1,.88.88V18.09a.44.44,0,0,1-.45.44h-.87A.44.44,0,0,1,24.71,18.09Zm3.53-3.53V1.76H7.5a.44.44,0,0,1-.44-.45V.45A.44.44,0,0,1,7.5,0H29.12A.88.88,0,0,1,30,.88V14.56a.44.44,0,0,1-.45.44h-.87A.44.44,0,0,1,28.24,14.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialsInitiative);
export default __webpack_public_path__ + "static/media/icon-tutorials-initiative.be1d99bd778a04d13b55984ae538f88e.svg";
export { ForwardRef as ReactComponent };